import React, { useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Weather from "./Weather";
import { TempContext } from "./Helper";

function App() {
  const [celcius, setCelcius] = useState(false);
  return (
    <div>
      <div className="App container border rounded shadow p-3 mb-5 mt-4 rounded p-4 weatherApp">
        <TempContext.Provider value={{ celcius, setCelcius }}>
          <Weather defaultCity="Kharkiv" />
        </TempContext.Provider>
      </div>
      <div className="me">
        {" "}
        <a
          href="https://github.com/Diana-1307/weather-react"
          target="_blank"
          rel="noreferrer"
          className="gitHubLink"
        >
          Open Source Code
        </a>{" "}
        by Diana Bilousova
      </div>
    </div>
  );
}

export default App;
